import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/img/logo.png';
import { useLocation } from 'react-router-dom';
import { useSidebar } from '../../context/SidebarContext';

const Sidebar = () => {
  const location = useLocation();
    const { collapsed } = useSidebar();

  // Helper function to determine if the link is active
  const isLinkActive = (path) => location.pathname === path;

  const conference = isLinkActive('/homeEvent') || isLinkActive('/homeslider') || isLinkActive('/testimonials') || isLinkActive('/welcomeContent')||isLinkActive('/aboutus') || isLinkActive('/videosGallery') || isLinkActive('/homecontact') || isLinkActive('/conferenceQa');
  const webinar = isLinkActive('/webinarEvent') || isLinkActive('/webinarWelcomeContent') || isLinkActive('/webinarQa');
  const pastconferences = isLinkActive('/pastConfReport') || isLinkActive('/pastconfgallery') || isLinkActive('/pastconftestimonials') || isLinkActive('/pastConfAffilations') || isLinkActive('/pastconfproceedingsupload');
  const footerdetails = isLinkActive('/socialLinks') || isLinkActive('/footers');
  const pastwebinar = isLinkActive('/pastWebinarReport') || isLinkActive('/webinarvideo');
  const registrationsetup = isLinkActive('/registrationdates') || isLinkActive('/registrationTypesList') || isLinkActive('/regaddons') || isLinkActive('/registrationContent') || isLinkActive('/regpricesetup')||isLinkActive('/regPriceSetup');
  const abstract = isLinkActive('/abstractUpload') || isLinkActive('/abstractQa');

  return (
  <nav id="sidebar" className={`sidebar js-sidebar ${collapsed ? 'collapsed' : ''}`}>
    <div className="sidebar-content js-simplebar" data-simplebar="init">
      <div className="simplebar-wrapper" style={{ margin: '0' }}>
        <div className="simplebar-height-auto-observer-wrapper">
          <div className="simplebar-height-auto-observer"></div>
        </div>
        <div className="simplebar-mask">
          <div className="simplebar-offset" style={{ right: '0', bottom: '0' }}>
            <div
              className="simplebar-content-wrapper"
              tabIndex="0"
              role="region"
              aria-label="scrollable content"
              style={{ height: '100%', overflow: 'hidden scroll' }}
            >
              <div className="simplebar-content" style={{ padding: '0' }}>
                <NavLink className="sidebar-brand" to="#">
                    <img src={logo} width="200px" alt="Scientex Conferences" />
                </NavLink>
                  
                <ul className="sidebar-nav">
                
                {/* <li className="sidebar-item">
                    <NavLink className="sidebar-link" to="/dashboard">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-sliders align-middle" > <line x1="4" y1="21" x2="4" y2="14"></line> <line x1="4" y1="10" x2="4" y2="3"></line> <line x1="12" y1="21" x2="12" y2="12"></line> <line x1="12" y1="8" x2="12" y2="3"></line> <line x1="20" y1="21" x2="20" y2="16"></line> <line x1="20" y1="12" x2="20" y2="3"></line> <line x1="1" y1="14" x2="7" y2="14"></line> <line x1="9" y1="8" x2="15" y2="8"></line> <line x1="17" y1="16" x2="23" y2="16"></line> </svg>
                      <span className="align-middle">Dashboard</span>
                    </NavLink>
                  </li> */}

                  <li className="sidebar-header">Events Pages</li>
                  
                  <li className={`sidebar-item ${conference ? 'active' : ''}`}>
                    <NavLink data-bs-target="#conference" data-bs-toggle="collapse"
                      className="sidebar-link"
                      aria-expanded={conference ? 'true' : 'false'}
                    >
                      <i className="align-middle me-2 fas fa-fw fa-globe-americas"></i>
                      <span className="align-middle">Conference</span>
                    </NavLink>
                    <ul
                      id="conference"
                      className={`sidebar-dropdown list-unstyled collapse ${conference ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                      <li className={`sidebar-item ${isLinkActive('/homeEvent') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/homeEvent">
                          Conference Details
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/homeslider') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/homeslider">
                          Slider Banner
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/testimonials') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/testimonials">
                          Home Testimonials
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/welcomeContent') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/welcomeContent">
                          Welcome Content
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/aboutus') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/aboutus">
                          About Us
                        </NavLink>
                      </li>
                      {/* <li className={`sidebar-item ${isLinkActive('/supportingJournals') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/supportingJournals">
                          Supporting Journal
                        </NavLink>
                      </li> */}
                      <li className={`sidebar-item ${isLinkActive('/videosGallery') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/videosGallery">
                          Video Gallery
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/homecontact') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/homecontact">
                          Venue Details
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/conferenceQa') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/conferenceQa">
                          Conference QA
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className={`sidebar-item ${webinar ? 'active' : ''}`}>
                    <NavLink
                      data-bs-target="#webinar" data-bs-toggle="collapse"
                      className="sidebar-link"
                      aria-expanded={webinar ? 'true' : 'false'}
                    >
                      <i className="align-middle me-2 fas fa-fw fa-laptop"></i>
                      <span className="align-middle">Webinar</span>
                    </NavLink>
                    <ul
                      id="webinar"
                      className={`sidebar-dropdown list-unstyled collapse ${webinar ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                    <li className={`sidebar-item ${isLinkActive('/webinarEvent') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/webinarEvent">
                          Webinar Details
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/webinarWelcomeContent') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/webinarWelcomeContent">
                          Welcome Content
                        </NavLink>
                      </li>                      
                      <li className={`sidebar-item ${isLinkActive('/webinarQa') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/webinarQa">
                          Webinar QA
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  
                  <li className="sidebar-header">Past Events Pages</li>
                  <li className={`sidebar-item ${pastconferences ? 'active' : ''}`}>
                    <NavLink data-bs-target="#pastConferences" data-bs-toggle="collapse" 
                    className="sidebar-link" 
                    aria-expanded={webinar ? 'true' : 'false'}
                    >
                      
                    <i className="align-middle me-2 fas fa-fw fa-globe-asia"></i>
                      <span className="align-middle">Past Conferences</span>
                    </NavLink>
                    <ul
                      id="pastConferences"
                      className={`sidebar-dropdown list-unstyled collapse ${pastconferences ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                    <li className={`sidebar-item ${isLinkActive('/pastConfReport') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/pastConfReport">
                          Conference Report
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/pastconfgallery') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/pastconfgallery">
                          Conference Gallery
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/pastconftestimonials') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/pastconftestimonials">
                          Conference Testimonials
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/pastConfAffilations') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/pastConfAffilations">
                          Conference Attendees
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/pastconfproceedingsupload') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/pastconfproceedingsupload">
                          Conference Proceedings
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  <li className={`sidebar-item ${pastwebinar ? 'active' : ''}`}>
                    <NavLink data-bs-target="#pastWebinar" data-bs-toggle="collapse" 
                    className="sidebar-link" 
                    aria-expanded={pastwebinar ? 'true' : 'false'}
                    >
                    <i className="align-middle me-2 fas fa-fw fa-laptop"></i>
                      <span className="align-middle">Past Webinar</span>
                    </NavLink>
                    <ul
                      id="pastWebinar"
                      className={`sidebar-dropdown list-unstyled collapse ${pastwebinar ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                    <li className={`sidebar-item ${isLinkActive('/pastWebinarReport') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/pastWebinarReport">
                          Webinar Report
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/webinarvideo') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/webinarvideo">
                          Webinar Videos
                        </NavLink>
                      </li>
                    </ul>
                  </li>
          
                  <li className="sidebar-header">Basic Setup & File upload</li>
                  <li className={`sidebar-item ${registrationsetup ? 'active' : ''}`}>
                    <NavLink
                      data-bs-target="#registration"
                      data-bs-toggle="collapse"
                      className="sidebar-link"
                      aria-expanded={registrationsetup ? 'true' : 'false'}
                      >
                      <i className="align-middle me-2 fas fa-fw fa-dollar-sign"></i>
                      <span className="align-middle">Registration Setup</span>
                    </NavLink>
                    <ul
                      id="registration"
                      data-bs-parent="#sidebar"
                      className={`sidebar-dropdown list-unstyled collapse ${registrationsetup ? 'show' : ''}`}
                    >
                    <li className={`sidebar-item ${isLinkActive('/registrationdates') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/registrationdates">
                          Reg. Dates
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/registrationTypesList') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/registrationTypesList">
                          Reg. Types
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/regpricesetup') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/regpricesetup">
                          Reg. Price Setup
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/regaddons') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/regaddons">
                          Reg. Addons
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/registrationContent') ? 'active' : ''}`}>
                        <NavLink className="sidebar-link" to="/registrationContent">
                          Reg. QA
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/scientificProgram') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/scientificProgram">
                    <i className="align-middle me-2 fas fa-fw fa-file-pdf"></i>
                      <span className="align-middle">Scientific Program</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/webinarProgram') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/webinarProgram">
                    <i className="align-middle me-2 fas fa-fw fa-file-pdf"></i>
                      <span className="align-middle">Webinar Program</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/brochureuploads') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/brochureuploads">
                    <i className="align-middle me-2 fas fa-fw fa-file-pdf"></i>
                      <span className="align-middle">Brochure</span>
                    </NavLink>
                  </li>
                  {/* <li className={`sidebar-item ${isLinkActive('/abstractUpload') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/abstractUpload">
                    <i className="align-middle me-2 far fa-fw fa-file-alt"></i>
                      <span className="align-middle">Sample Abstract</span>
                    </NavLink>
                  </li> */}

                   <li className={`sidebar-item ${abstract ? 'active' : ''}`}>
                    <NavLink
                      data-bs-target="#abstract" data-bs-toggle="collapse"
                      className="sidebar-link"
                      aria-expanded={abstract ? 'true' : 'false'}
                    >
                      <i className="align-middle me-2 fas fa-fw fa-laptop"></i>
                      <span className="align-middle">Abstract</span>
                    </NavLink>
                    <ul
                      id="abstract"
                      className={`sidebar-dropdown list-unstyled collapse ${abstract ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                    <li className={`sidebar-item ${isLinkActive('/abstractUpload') ? 'active' : ''}`}>
                       <NavLink className="sidebar-link" to="/abstractUpload">
                          <span className="align-middle">Sample Abstract</span>
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/abstractQa') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/abstractQa">
                          Abstract QA
                        </NavLink>
                      </li>                      
                    </ul>
                  </li>
                  
                  <li className="sidebar-header">Other Pages</li>
                  <li className={`sidebar-item ${isLinkActive('/sessions') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/sessions">
                    <i className="align-middle me-2 fas fa-fw fa-list"></i>
                      <span className="align-middle">Sessions</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/ocm') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/ocm">
                    <i className="align-middle me-2 fas fa-fw fa-user-friends"></i>
                      <span className="align-middle">Committee members</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/speakers') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/speakers">
                    <i className="align-middle me-2 fas fa-fw fa-users"></i>
                      <span className="align-middle">Speakers</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/venue') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/venue">
                    <i className="align-middle me-2 fas fa-fw fa-map-marked-alt"></i>
                      <span className="align-middle">Venue</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/supportingJournals') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/supportingJournals">
                    <i className="align-middle me-2 fas fa-fw fa-book"></i>
                      <span className="align-middle">Supporting Journals</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/mediaPartners') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/mediaPartners">
                    <i className="align-middle me-2 fas fa-fw fa-clone"></i>
                      <span className="align-middle">Media Partners</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/guidelines') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/guidelines">
                    <i className="align-middle me-2 fas fa-fw fa-align-justify"></i>
                      <span className="align-middle">Guidelines</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/termsAndConditions') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/termsAndConditions">
                    <i className="align-middle me-2 fas fa-fw fa-align-justify"></i>
                      <span className="align-middle">Terms & Conditions</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${footerdetails ? 'active' : ''}`}>
                    <NavLink data-bs-target="#footerDetails" data-bs-toggle="collapse" 
                    className="sidebar-link collapsed" 
                    aria-expanded={footerdetails ? 'true' : 'false'}
                    >
                    <i className="align-middle me-2 far fa-fw fa-caret-square-down"></i>
                      <span className="align-middle">Footer Details</span>
                    </NavLink>
                    <ul
                      id="footerDetails"
                      className={`sidebar-dropdown list-unstyled collapse ${footerdetails ? 'show' : ''}`}
                      data-bs-parent="#sidebar"
                    >
                    <li className={`sidebar-item ${isLinkActive('/socialLinks') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/socialLinks">
                          Social Links
                        </NavLink>
                      </li>
                      <li className={`sidebar-item ${isLinkActive('/footers') ? 'active' : ''}`}>
                      <NavLink className="sidebar-link" to="/footers">
                          Contact Details
                        </NavLink>
                      </li>
                    </ul>
                  </li>

                  
                  <li className="sidebar-header">SEO Config</li>
                  <li className={`sidebar-item ${isLinkActive('/seoReport') ? 'active' : ''}`}>
                  <NavLink className="sidebar-link" to="/seoReport">
                    <i className="align-middle me-2 fas fa-fw fa-file-alt"></i>
                    <span className="align-middle">SEO Report</span>
                  </NavLink>
                </li>
                  <li className={`sidebar-item ${isLinkActive('/seoContent') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/seoContent">
                    <i className="align-middle me-2 fas fa-fw fa-stream"></i>
                      <span className="align-middle">Meta Tags</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/pastEventSeo') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/pastEventSeo">
                    <i className="align-middle me-2 fas fa-fw fa-database"></i>
                      <span className="align-middle">past Event SEO</span>
                    </NavLink>
                  </li> 
                  <li className={`sidebar-item ${isLinkActive('/seoSchemaMarkup') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/seoSchemaMarkup">
                    <i className="align-middle me-2 fas fa-fw fa-database"></i>
                      <span className="align-middle">Schema Markup</span>
                    </NavLink>
                  </li>
                  
                  {/* <li className={`sidebar-item ${isLinkActive('/seoOpenGraphProtocol') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/seoOpenGraphProtocol">
                    <i className="align-middle me-2 fas fa-fw fa-chart-bar"></i>
                      <span className="align-middle">Open Graph Protocol</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/seoTwitterCard') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/seoTwitterCard">
                    <i className="align-middle me-2 fab fa-fw fa-twitter"></i>
                      <span className="align-middle">Twitter Card</span>
                    </NavLink>
                  </li> */}
                  <li className={`sidebar-item ${isLinkActive('/UploadAnalytics') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/UploadAnalytics">
                    <i className="align-middle me-2 fas fa-fw fa-chart-line"></i>
                      <span className="align-middle">Upload Analytics ID</span>
                    </NavLink>
                  </li>
                  <li className={`sidebar-item ${isLinkActive('/seoXmlSitemap') ? 'active' : ''}`}>
                    <NavLink className="sidebar-link" to="/seoXmlSitemap">
                    <i className="align-middle me-2 fas fa-fw fa-sitemap"></i>
                      <span className="align-middle">XML Sitemap</span>
                    </NavLink>
                  </li>
                  <li className="sidebar-item py-3"></li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  );
};

export default Sidebar;